import { render, staticRenderFns } from "./newVehicle.vue?vue&type=template&id=09600d8d&scoped=true&"
import script from "./newVehicle.vue?vue&type=script&lang=js&"
export * from "./newVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09600d8d",
  null
  
)

export default component.exports